import Vue from 'vue'
import Vuex from 'vuex'
import services from '@/services/services'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken: null,
    isLoading: false,
    snackbar: {},
    modal: false,
    userId: null,
    user_list: [],
    service_list: [],
    admin: {
      events: [],
      chats: [
        {
          coordinator_id: 123,
          title: 'issue',
          user_id: 'user1',
          content: 'This is chat 1',
          createdAt: '2019-06-10 09:29:55.761-07',
          location: 'Seattle'
        },
        {
          coordinator_id: 456,
          title: 'issue',
          user_id: 'user2',
          content: 'This is chat 2',
          createdAt: '2019-04-08 09:29:55.761-07',
          location: 'Miami'
        },
        {
          coordinator_id: 789,
          title: 'change',
          user_id: 'user3',
          createdAt: '2019-11-21 09:29:55.761-07',
          location: 'Phoenix',
          content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.'
        }
      ]
    },
    user: {
      ranked_categories: [
        { title: 'Driving', views: 311, books: 55 },
        { title: 'Car Rental', views: 0, books: 0 },
        { title: 'Stay', views: 0, books: 3 },
        { title: 'Food', views: 2, books: 78 },
        { title: 'Maid', views: 0, books: 0 },
        { title: 'Travel', views: 0, books: 0 },
        { title: 'Health & Beauty', views: 0, books: 0 },
        { title: 'Medical', views: 0, books: 0 },
        { title: 'Party', views: 300, books: 40 },
        { title: 'Security', views: 202, books: 22 },
        { title: 'Venue Booking', views: 0, books: 0 },
        { title: 'Couture', views: 0, books: 0 },
        { title: 'Personal Assistance', views: 107, books: 15 },
        { title: 'Media', views: 111, books: 10 },
        { title: 'Ticketing', views: 0, books: 0 },
        { title: 'Off Road Rental', views: 0, books: 0 },
        { title: 'Aircraft', views: 320, books: 30 },
        { title: 'Watercraft Rental', views: 0, books: 0 }
      ],
      info: {},
      general: {},
      events: [],
      service_cart: []
    }
  },
  mutations: {
    authUser (state, payload) {
      state.idToken = payload.token
      state.userId = +payload.userId
    },
    resetState (state) {
      state.idToken = null
      state.userId = null
      state.user_list = []
      state.service_list = []
      state.admin = { events: [] }
      state.user = {
        info: {},
        general: {},
        events: [],
        service_cart: []
      };
    },
    addUserData (state, payload) {
      const type = payload.data_type
      delete payload.data_type
      state.user[type] = payload
    },
    showSnackbar (state, payload) {
      state.snackbar = payload
    },
    setLoading (state, payload) {
      state.isLoading = payload
    },
    setUserList (state, payload) {
      state.user_list = payload
    },
    setUserChat (state, payload) {
      state.admin.chats = payload
    },
    setUserEvents (state, payload) {
      state.user.events = payload
    },
    setAdminEvents (state, payload) {
      state.admin.events = payload
    },
    setAllServices (state, payload) {
      state.service_list = payload
    },
    setUserBooks(state, payload) {
      state.user.ranked_categories = payload;
    },
    setModal(state, payload) {
      state.modal = payload;
    },
    setUserCategories(state, payload) {
      state.user.ranked_categories = payload;
    },
    setUserServiceCart(state, payload) {
      state.user.service_cart = payload;
    },
  },
  actions: {
    setUser ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        if (!payload.id) {
          const error = 'No User'
          reject(error)
        }

        commit('authUser', {
          token: payload.token,
          userId: payload.id
        })

        localStorage.setItem('royal_experience_token', payload.token)
        localStorage.setItem('royal_experience_userId', payload.id)

        commit('addUserData', {
          phone: payload.phone,
          email: payload.email,
          name: payload.name,
          admin: payload.admin,
          data_type: 'info'
        })

        resolve()
      })
    },
    unsetUser ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('resetState')
        localStorage.removeItem('royal_experience_token')
        localStorage.removeItem('royal_experience_userId')

        resolve()
      })
    },
    // Updates general user information
    // param (payload): JSON to update general info
    setUserData ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        const service_map = {
          general: services.setUserGeneral
        }

        service_map[payload.data_type]({
          id: state.userId,
          age: payload.age,
          gender: payload.gender,
          business_name: payload.business_name,
          business_type: payload.business_type,
          business_size: payload.business_size,
          base_location: payload.base_location,
          locations: payload.locations,
          type: payload.type
        })
          .then((resp) => {
            commit('addUserData', payload)
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    // Gets user information
    // param (payload): JSON to update general info
    getUserData ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        const service_map = {
          general: services.getUserGeneral
        }

        service_map[payload.data_type](state.userId)
          .then((resp) => {
            commit('addUserData', {...resp.data, data_type: payload.data_type})
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    createEvent ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.createEvent({...payload, id: state.userId})
          .then((resp) => {
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    createEventRequest ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.createEventRequest({...payload, id: state.userId})
          .then((resp) => {
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    getUsers ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.getAllUsers()
          .then((resp) => {
            commit('setUserList', resp.data)
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    getEvents ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.getEvents(state.userId)
          .then((resp) => {
            commit('setUserEvents', resp.data)
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    getAllUserEvents ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.getAllUserEvents()
          .then((resp) => {
            commit('setAdminEvents', resp.data)
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    getAllServices ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.getAllServices()
          .then((resp) => {

            commit('setAllServices', resp.data)
            commit('setLoading', false)
            resolve()
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    getAllServiceFilters ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        if (!state.idToken) {
          const error = 'No Current User'
          commit('setLoading', false)
          reject(error)
        }

        services.getAllServiceFilters()
          .then((resp) => {

            commit('setLoading', false)
            resolve(resp.data)
          })
          .catch((err) => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    handleModal({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        if (!state.idToken) {
          const error = 'No Current User';
          commit('setLoading', false);
          reject(error);
        }

        commit('setModal', payload);
        // todo: persist data w/ api request
      });
    },
    updateUserBooks({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        if (!state.idToken) {
          const error = 'No Current User';
          commit('setLoading', false);
          reject(error);
        }
        let categories = [...state.user.ranked_categories];
        for (let i = 0; i < categories.length; i++) {
          for (let j = 0; j < payload.length; j++) {
            if (categories[i].title === payload[j]) {
              categories[i].books++;
            }
          }
        }
        commit('setUserBooks', categories);
        // todo: persist data w/ api request
      });
    },
    updateUserCategories({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        if (!state.idToken) {
          const error = 'No Current User';
          commit('setLoading', false);
          reject(error);
        }

        let categories = [...state.user.ranked_categories];
        for (let i = 0; i < categories.length; i++) {
          if (categories[i].title === payload.title) {
            categories[i] = payload;
          }
        }
        commit('setUserCategories', categories);
        // todo: persist data w/ api request
      });
    },
    addServiceToCart({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        if (!state.idToken) {
          const error = 'No Current User';
          commit('setLoading', false);
          reject(error);
        }
        let cart = [...state.user.service_cart, payload];
        commit('setUserServiceCart', cart);
        commit('setModal', false);
        // todo: persist data w/ api request
      });
    },
    updateServiceInCart({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        if (!state.idToken) {
          const error = 'No Current User';
          commit('setLoading', false);
          reject(error);
        }
        let cart = [...state.user.service_cart];
        for (let i = 0; i < cart.length; i++) {
          if (cart[i].id === payload.id) {
            cart[i] = payload;
          }
        }
        commit('setUserServiceCart', cart);
        commit('setModal', false);
        // todo: persist data w/ api request
      });
    },
    createChat({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        if (!state.idToken) {
          const error = 'No Current User';
          commit('setLoading', false);
          reject(error);
        }

        services
          .createChat({ ...payload, id: state.userId })
          .then(resp => {
            commit('setLoading', false);

            const chats = [...state.admin.chats, payload];
            commit('setUserChat', chats);
            resolve();
          })
          .catch(err => {
            commit('setLoading', false);
            reject(err);
          });
      });
    },
  },
  getters: {
    getAuth (state) {
      return { token: state.idToken, userId: state.userId }
    },
    user (state) {
      return state.user
    },
    isLoading (state) {
      return state.isLoading
    },
    isAdmin (state) {
      return state.user.info.admin
    },
    getEvents (state) {
      return state.user.events
    },
    getServiceCart (state) {
      return state.user.service_cart
    },
    getAdminEvents (state) {
      return state.admin.events
    },
    getAdminChats (state) {
      return state.admin.chats
    },
    getUserChats (state) {
      return state.admin.chats
    },
    getAdminEvents (state) {
      return state.admin.events
    },
    getUsers (state) {
      return state.user_list
    },
    getServiceList (state) {
      return state.service_list
    },
    getUserRankedList (state) {
      return state.user.ranked_categories
    },
    getModal (state) {
      return state.modal
    }
  }
})
